<template>
  <div class="check">
    <h1>お知らせ内容登録</h1>
    <input v-model="title" type="text" placeholder="タイトル" style="font-size:18px;width: 400px; height: 30px;border-collapse: collapse; margin-bottom: 20px;">
    <textarea v-model="message" placeholder="お知らせ内容を入力して下さい" style="display: flex; margin: 0 auto; width: 400px; height: 350px;"></textarea>
    <button style="margin-top: 30px; padding: 10px;" @click="submit">登録</button>
  </div>
</template>

<script>
import { firestore } from '../firebase/firestore'
// import algoliasearch from 'algoliasearch'
const notificationAdmin = firestore.collection('notification_admin')
// const client = algoliasearch(process.env.VUE_APP_ID, process.env.VUE_APP_PASSWORD)
export default {
  name: 'check',
  data () {
    return {
      message: '',
      title: '',
      uid: '',
      fileName: ''
    }
  },
  mounted () {
    let isLogin = localStorage.getItem('login')
    if (!isLogin) {
      this.$router.push('/gourmet/check-login')
    }
  },
  methods: {
    submit () {
      let date = new Date()
      date = date.toLocaleString()
      const payload = {
        'content': this.message,
        'firebase_uid': 'Fp4MUlqYGEebVCJEynZ1S6vCkug2',
        'is_read': [],
        'notification_admin_id': '',
        'thumbnail_url': '',
        'created_at': date,
        'updated_at': date,
        'title': this.title,
        'deleted_at': null
      }
      notificationAdmin.add(payload).then(doc => {
        console.log(doc.id)
        console.log(notificationAdmin.doc(doc.id))
        notificationAdmin.doc(doc.id).update({
          'notification_admin_id': doc.id
        })
        location.reload()
      }).catch(err => {
        console.error('Error adding document: ', err)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

video, img {
  width: 320px
}
</style>



// WEBPACK FOOTER //
// src/components/alert.vue